import { render, staticRenderFns } from "./OrderPayDetail.vue?vue&type=template&id=fcab4b70"
import script from "./OrderPayDetail.vue?vue&type=script&lang=js"
export * from "./OrderPayDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports